function d(c, s, t) {
  c != 0 ? s.classList.add(t) : s.classList.remove(t);
}
export { d };